/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CommentEntity = {
  type: 'Enum',
} as const;
